import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CART_LINE_TYPES } from '../../../cart/constants/common';
import { ICakeCartLine } from '../../../cart/models/cart/i-cake-cart-line';

import { PRODUCT_TYPE_STRUCTURE_TYPES, CustomComponent } from '@cakeiteasy/web-utils';
import { Subject } from 'rxjs';
import { cartHelper } from '../../../cart';

@Component({
  standalone: false,
  selector: 'mobile-cart-product-item',
  templateUrl: './mobile-cart-product-item.component.html',
  styleUrls: ['./mobile-cart-product-item.component.scss']
})
export class MobileCartProductItemComponent extends CustomComponent implements OnInit {
  @Input() orderLine: ICakeCartLine;
  @Input() orderLines: ICakeCartLine[];
  @Input() currency: string;

  @Output() onCountUpdate = new EventEmitter<number>();
  @Output() onEdit = new EventEmitter<ICakeCartLine>();
  @Output() onRemoveOrderLine = new EventEmitter<ICakeCartLine>();

  public isComplex: boolean;
  public count$ = new Subject<number>();
  public CART_LINE_TYPES = CART_LINE_TYPES;

  ngOnInit() {
    this.isComplex = this.orderLine.productType.structureType === PRODUCT_TYPE_STRUCTURE_TYPES.COMPLEX;

    this.addSubscriber(this.count$
      .subscribe((count) => this.onCountUpdate.emit(count)));
  }

  public minQuantity(line: ICakeCartLine) {
    return cartHelper.getMinQuantityForOrderLine(line, this.orderLines);
  }

  public maxQuantity(line: ICakeCartLine) {
    return cartHelper.getMaxQuantityForOrderLine(line, this.orderLines);
  }
}
